import React from 'react';
import { Button } from '@mui/material';
import { authApi } from '../../api/auth';
import { ReactComponent as GoogleIcon } from '../../assets/google.svg';

const GoogleLoginButton = ({ redirectUrl }) => {
  const handleOnClick = async () => {
    try {
      const { data } = await authApi.getGoogleUrl(redirectUrl);
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Error fetching Google URL:', error);
    }
  };

  return (
    <Button
      fullWidth
      startIcon={<GoogleIcon width={40} height={40} aria-hidden />}
      onClick={handleOnClick}
      sx={{
        backgroundColor: 'transparent !important',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
        },
        '&:active': {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
        },
        '&:focus': {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
        },
        '&.Mui-focusVisible': {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
        },
        '&.MuiButton-root': {
          backgroundColor: 'transparent !important',
        },
        '& .MuiTouchRipple-root': {
          display: 'none',
        },
      }}
    />
  );
};

export default GoogleLoginButton;
